import React, { useEffect, useRef, useState } from "react";
import { Button, Radio, Input, Tooltip, Checkbox, Popover } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { getShareableId } from "../../../../redux/actions/ApiCall/apiCall";
import { useDispatch, useSelector } from "react-redux";
import {
  getPaneIndex,
  getCustomizedDate,
  getDefaultCompBrand,
  getByDefaultProfileFilters,
  removePrivateConversationFilters,
  removeHiddenAndQuickFilters,
  getSimilarStaticFilter,
  generateTimeOptions,
  processQuickFilterForADCampaign,
  callNotification,
  removeMatchingFilters,
  getChannelNameFromHiddenFilter,
  processQuickFilterForScheduleADCampaign,
} from "../../../../redux/constants";
import moment from "moment";
import BrandsLogicalGroup from "../../../layout/WelcomePage/Template/BrandsLogicalGroup";
import AccountList from "../../../layout/WelcomePage/Template/AccountList";
import ProfileSelection from "../../../layout/WelcomePage/Template/ProfileSelection";
import { SetExpiryDatePicker } from "./SetExpiryDatePicker";
import Calender_blue from "../../../../assets/Calender_blue.svg";
import Clock from "../../../../assets/Clock.svg";
import informationButton from "../../../../assets/information-button.svg";
import {
  resetSelectedProfileInfoInShareModal,
  setSelectedInitailProfileInfoInShareModal,
} from "../../../../redux/actions/share/Share";

const SharePassword = ({
  isModalShare,
  handleChangeShare,
  selectedUserId,
  setSelectedUserId,
  setDeselectId,
  selectedUserData,
  bottom,
}) => {
  const dispatch = useDispatch();
  const [valuePassword, setValuePassword] = useState(2);
  const [shareableLink, setShareableLink] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [checkboxValue, setcheckboxValue] = useState({
    deep_dive_enabled: true,
    filter_icon_enabled: true,
    relative_dutation_enabled: false,
    allow_multiple_selection: false,
    allow_multiple_brand: false,
  });
  const sharedAccount = useSelector((state) => state.Share.sharedAccount);
  const shareableData = useSelector((state) => state.dashboard.shareableData);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const shareableUrl = useSelector((state) => state.ApiCall.shareableLink);
  const sharedBrands = useSelector((state) => state.Share.sharedBrands);
  const profileSelectionInfo = useSelector(
    (state) => state?.Share?.profileSelectionInfo
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );

  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);

  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  // const profileFilterList = useSelector(
  //   (state) => state?.apiCall?.profile_filter_list
  // );
  const templateDetails = useSelector((state) => state.Section.templateDetails);

  let index = getPaneIndex(panes, activeKey);
  const profileFilterList =
    window.location.pathname?.split("/")?.[1] === "edit-dashboard" ||
    window.location.pathname?.split("/")?.[1] === "create-dashboard"
      ? templateDetails?.profile_filters_list
      : panes?.[index]?.profile_filters_list;

  const profileList = useSelector((state) => state.WidgetAPI.profileList);
  const workspace_privileges = useSelector(
    (state) => state?.ApiCall?.workspace_privileges
  );
  const selectedDate = panes[index].duration;

  const [sendModifyData, setSendModifyData] = useState([]);
  const [passwordError, setPasswordError] = useState(false);

  const [upperColor, setUpperColor] = useState();
  const [lowerColor, setLowerColor] = useState();
  const [specialColor, setSpecialColor] = useState();
  const [numberColor, setNumberColor] = useState();
  const [minColor, setMinColor] = useState();

  const [showLink, setShowLink] = useState(false);
  const [showRadio, setShowRadio] = useState(true);
  const [password, setPassword] = useState();
  const [datePicker, setDatepicker] = useState(false);
  const [localDate, setLocalDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("11:59 PM");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showDateTime, setShowDateTime] = useState(false);
  const refDate = useRef(null);
  const timeOptions = generateTimeOptions();
  const dropdownRef = useRef(null);
  const handleOpenChange = (newOpen) => {
    setDatepicker(newOpen);
  };

  const handleExpiryDateVisibility = (e) => {
    setShowDateTime(!showDateTime);
    setLocalDate(null);
  };

  const onOpen = (e) => {
    if (refDate?.current && !refDate?.current?.contains(e.target)) {
      setDatepicker(false);
    } else {
      setDatepicker(true);
    }
  };

  const onDoneButton = () => {
    setDatepicker(false);
  };
  const isTimeDisabled = (time) => {
    const selectedDate = moment(localDate, "YYYY/MM/DD");
    const currentMoment = moment();

    const optionMoment = moment(
      `${selectedDate.format("YYYY/MM/DD")} ${time}`,
      "YYYY/MM/DD hh:mm A"
    );

    if (selectedDate.isSame(currentMoment, "day")) {
      return optionMoment.isBefore(currentMoment, "minute");
    }

    return false;
  };

  const handleTimeSelect = (time) => {
    if (isTimeDisabled(time)) return;
    setSelectedTime(time);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (shareableUrl) {
      setIsLoading(false);
      setShareableLink(true);
    }
  }, [shareableUrl]);

  useEffect(() => {
    let newArray = selectedUserId?.map((s) => {
      return { user_id: s, access_type: 1 };
    });
    setSendModifyData(newArray);
  }, [selectedUserId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current?.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const onCopy = React.useCallback(() => {
    setIsCopied(true);
  }, []);
  const handlePasswordOption = (e) => {
    setValuePassword(e.target.value);
    // e.target.value === 1
    //   ? setcheckboxValue(null)
    //   : setcheckboxValue("deep_dive_enabled");
    setUpperColor();
    setLowerColor();
    setSpecialColor();
    setNumberColor();
    setMinColor();
    setPasswordError(false);
  };

  const handleChangePassword = (e) => {
    let text = e.target.value;

    if (text.match(/[A-Z]/)) {
      setUpperColor(true);
    } else {
      setUpperColor(false);
    }

    if (text.match(/[a-z]/)) {
      setLowerColor(true);
    } else {
      setLowerColor(false);
    }

    if (text.match(/[!\@\#\$\%\^\&\*]/)) {
      setSpecialColor(true);
    } else {
      setSpecialColor(false);
    }

    if (text.match(/[0-9]/)) {
      setNumberColor(true);
    } else {
      setNumberColor(false);
    }

    if (text.length >= 8) {
      setMinColor(true);
    } else {
      setMinColor(false);
    }
    setPassword(text);
  };

  const handleCheckbox = (e) => {
    const { value, checked } = e.target;
    setcheckboxValue((prevState) => ({
      ...prevState,
      [value]: checked,
    }));
  };
  useEffect(() => {
    if (checkboxValue?.allow_multiple_selection) {
      dispatch(
        setSelectedInitailProfileInfoInShareModal(
          panes?.[index]?.profileInfo,
          panes?.[index]?.quick_filter_value,
          panes?.[index]?.adsset_list,
          panes?.[index]?.adsset_value,
          panes?.[index]?.ads_list,
          panes?.[index]?.ads_value
        )
      );
    } else {
      dispatch(resetSelectedProfileInfoInShareModal());
    }
  }, [checkboxValue?.allow_multiple_selection]);

  const generateSharableLink = () => {
    if (
      valuePassword == 1 ||
      (upperColor && lowerColor && specialColor && numberColor && minColor)
    ) {
      let twoMonthsDuration = getCustomizedDate(6, "Days");
      let defaultDuration = {
        from:
          moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.startTime,
        to:
          moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.endTime,
      };

      let defaultProfileFilters = getByDefaultProfileFilters(profileFilterList);

      let campaignList = profileList?.data?.result;
      let quickFilterValue =
        checkboxValue?.allow_multiple_selection &&
        profileSelectionInfo?.quick_filter_value
          ? profileSelectionInfo?.quick_filter_value
          : panes?.[index]?.quick_filter_value
          ? panes?.[index]?.quick_filter_value
          : null;
      let quick_filter = quickFilterValue
        ? quickFilterValue?.columns?.[0]?.name
        : null;
      // panes[index]?.filters?.filter(
      //   (el) => el?.attribute === "CampaignID"
      // )?.[0]?.columns?.[0]?.name;

      let final_filters = panes?.[index]?.filters
        ? panes?.[index]?.filters
        : [];
      // let quickFilterAttribute =
      //   panes?.[index].quick_filter === "AccountID"
      //     ? "SettingID"
      //     : panes?.[index]?.quick_filter === "Category"
      //     ? "CategoryID"
      //     : panes?.[index].quick_filter;

      // let quick_filter1 = quickFilterAttribute
      //   ? [
      //       {
      //         attribute: quickFilterAttribute,
      //         type: "varchar",
      //         columns: [
      //           {
      //             name:
      //               panes?.[index]?.quick_filter === "Category"
      //                 ? (panes?.[index]?.profiles?.[0]?.id).toString()
      //                 : (panes?.[index]?.profiles?.[0]?.id).toString(),
      //             type: "include",
      //           },
      //         ],
      //       },
      //     ]
      //   : [];

      // let saved_similar_quick_filter_obj = getSimilarStaticFilter(
      //   [],
      //   panes?.[index]?.filters,
      //   quick_filter1
      // );
      // let saved_similar_hidden_filter_obj = getSimilarStaticFilter(
      //   panes?.[index]?.hidden_filter ? [panes?.[index]?.hidden_filter] : [],
      //   panes?.[index]?.filters,
      //   []
      // );

      let selectedCampaign = campaignList?.filter((d) => d?.id == quick_filter);

      if (panes?.[index]?.template_type === "competition") {
        final_filters = removePrivateConversationFilters(
          panes?.[index]?.comp_hidden_filter,
          panes?.[index]?.filters,
          panes?.[index]?.filters?.length ===
            panes?.[index]?.saved_filters?.length
            ? []
            : panes?.[index]?.saved_filters
        );
      }
      let newFilterArray = [];
      // change filter array if quick filter is selected
      const isValidObject = (obj) => {
        return obj && Object.keys(obj).length > 0;
      };

      if (
        panes[index]?.selected_pills &&
        panes[index]?.selected_pills?.length &&
        panes[index]?.selected_pills.some((pill) => isValidObject(pill))
      ) {
        newFilterArray = removeMatchingFilters(
          panes[index]?.filters,
          panes[index]?.selected_pills
        );
        callNotification(
          "Applied quick filter has been removed, re-apply in shared view",
          "info"
        );
      } else {
        // if no selected quick filter keep same
        newFilterArray = final_filters;
      }

      // if (panes?.[index]?.hidden_filter || panes?.[index]?.quick_filter) {
      //   final_filters = removeHiddenAndQuickFilters(
      //     panes?.[index]?.quick_filter,
      //     panes?.[index]?.hidden_filter,
      //     final_filters
      //   );
      // }

      // let saved_similar_quick_filter = saved_similar_quick_filter_obj?.filter;
      // if (saved_similar_quick_filter?.length) {
      //   final_filters = [...final_filters, ...saved_similar_quick_filter];
      // }
      // let saved_similar_hidden_filter = saved_similar_hidden_filter_obj?.filter;
      // if (saved_similar_hidden_filter?.length) {
      //   final_filters = [...final_filters, ...saved_similar_hidden_filter];
      // }
      // In Shared campaign dashboard, duration will be campaign duration
      // panes[index]?.quick_filter === "CampaignID" this logic added
      let dashLinkExpiryDate = !showDateTime
        ? null
        : localDate
        ? localDate + ` ${moment(selectedTime, "hh:mm A").format("HH:mm")}`
        : null;
      let relative_duration = panes?.[index]?.duration?.save_as_relative
        ? {
            is_relative: panes?.[index]?.duration?.relative?.type === "short",
            relative_type: panes?.[index]?.duration?.relative?.value ?? null,
            // relative_days: panes?.[index]?.duration?.days ?? null,
            relative_days: null, // For now sending null
          }
        : null;

      let graphObject = {
        start_date:
          panes[index]?.quick_filter === "CampaignID"
            ? selectedCampaign?.[0]?.start_date
            : selectedDate
            ? selectedDate?.from
            : defaultDuration?.from,
        end_date:
          panes[index]?.quick_filter === "CampaignID"
            ? selectedCampaign?.[0]?.end_date
            : selectedDate
            ? selectedDate?.to
            : defaultDuration?.to,
        linkExpiryDate: dashLinkExpiryDate,
        password: password ? password : null,
        deep_dive_enabled: checkboxValue?.deep_dive_enabled ? true : false,
        filter_icon_enabled: checkboxValue?.filter_icon_enabled ? true : false,
        relative_duration: checkboxValue?.relative_dutation_enabled
          ? relative_duration
            ? relative_duration
            : { allow_relative: true }
          : null,
        allow_multiple_selection: checkboxValue?.allow_multiple_selection
          ? true
          : false,
        allow_multiple_brand: checkboxValue?.allow_multiple_brand
          ? true
          : false,
        profile_filters: defaultProfileFilters ? defaultProfileFilters : null,
        filters: newFilterArray,
        selected_account_list: sharedAccount,
      };
      let comp_brands =
        panes[index]?.template_type === "competition"
          ? getDefaultCompBrand(competitorBrands)
          : null;

      // new logic for formatting subset_filter in inner of columns
      let updatedColumnsMap = null;
      if (panes[index]?.quick_filter === "Ads_Campaign") {
        // Example call to the function
        updatedColumnsMap =
          profileSelectionInfo?.is_value_updated_from_share_modal
            ? processQuickFilterForScheduleADCampaign(
                // used common function for both share and schedule
                profileSelectionInfo?.quick_filter_value,
                profileSelectionInfo?.adsset_value,
                profileSelectionInfo?.ads_value
              )
            : processQuickFilterForADCampaign(panes, index);
      }
      let quickFilterWithSubsetFilter = null;
      if (
        updatedColumnsMap &&
        Array.from(updatedColumnsMap?.values())?.length
      ) {
        quickFilterWithSubsetFilter = quickFilterValue
          ? { ...quickFilterValue }
          : null;
        if (
          quickFilterWithSubsetFilter?.columns &&
          Array.isArray(quickFilterWithSubsetFilter?.columns)
        )
          quickFilterWithSubsetFilter.columns = Array.from(
            updatedColumnsMap?.values()
          );
      }
      let profileData = {
        hidden_filter: panes[index]?.hidden_filter,
        quick_filter: quickFilterWithSubsetFilter
          ? quickFilterWithSubsetFilter
          : quickFilterValue
          ? quickFilterValue
          : null,
      };
      authParams &&
        dispatch(
          getShareableId(
            shareableData?.template_id,
            authParams,
            sharedBrands?.columns
              ? sharedBrands?.columns
              : panes[index]?.brands
              ? panes[index]?.brands
              : comp_brands,
            "share_id",
            brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
            graphObject.start_date,
            graphObject.end_date,
            valuePassword === 1 ? null : graphObject.password,
            profileData,
            graphObject
          )
        );

      setShowLink(true);
      setShowRadio(false);
    }
  };

  const onCancel = (e) => {
    setDatepicker(false);
  };
  const getNameFromQuickFilter = (quickFilterAttribute) => {
    return quickFilterAttribute === "SettingID" ||
      quickFilterAttribute === "AccountID"
      ? "Profile"
      : quickFilterAttribute === "ObjectID"
      ? "Form"
      : quickFilterAttribute === "LocationID"
      ? "Location"
      : quickFilterAttribute?.toLowerCase() === "fbgroupid"
      ? "Facebook Group"
      : quickFilterAttribute === "Ticket_Tagging"
      ? "Label"
      : quickFilterAttribute === "CategoryID"
      ? "Category"
      : quickFilterAttribute === "Ads_Campaign"
      ? "AD Campaign"
      : quickFilterAttribute === "ProfileID"
      ? "Location Profile"
      : quickFilterAttribute === "CampaignID"
      ? "Campaign"
      : "";
  };

  let quick_filters =
    window.location.pathname === "/dashboard" ||
    window.location.pathname === "/pin-dashboard"
      ? graphConditionConfig &&
        graphConditionConfig?.single_brand_select?.includes(
          panes?.[index]?.template_id
        )
        ? true
        : panes && panes?.[index]?.quick_filter
        ? true
        : false
      : false;
  let brandlist_brandgroup_select =
    window.location.pathname === "/dashboard" ||
    window.location.pathname === "/pin-dashboard"
      ? graphConditionConfig &&
        graphConditionConfig?.brandlist_brandgroup_select?.includes(
          panes?.[index]?.template_id
        )
        ? true
        : false
      : false;

  let isOrmUser = workspace_privileges?.login_access_type == 1 ? true : false;

  const showAllowBrandSwitching =
    !quick_filters && !brandlist_brandgroup_select && !isOrmUser;

  return (
    <div className="bg__white" style={{ borderRadius: "0 0 0.4rem 0.4rem" }}>
      {/*this is to conditionally render account list in share */}
      {panes?.[index]?.selected_account_list?.length > 0 ? (
        <div
          className={`floating-label-group header-brands mt-2 mb-2 ml-15 mr-15`}
          style={
            shareableUrl || panes[index]?.quick_filter
              ? {
                  pointerEvents: "none",
                  opacity: "0.6",
                  minWidth: "18rem",
                }
              : { minWidth: "18rem" }
          }
        >
          {/* <AccountList /> */}
          <div
            className={`${panes?.[index]?.is_brand_locked ? "disable" : ""}`}
          >
            <AccountList type="share-modal" />
          </div>
          <label
            className="portlet-label floating-label mr-15"
            style={{
              backgroundColor: "#fff",
              top: "-0.8rem",
              fontSize: "1.2rem",
            }}
          >
            For which account you would like to generate a link ?
            <span style={{ color: "red" }}>*</span>
          </label>
          {panes?.[index]?.selected_account_list?.length === 0 && (
            <div className="error font-size12">
              Account list cannot be empty
            </div>
          )}
        </div>
      ) : (
        <>
          {!showLink && showAllowBrandSwitching ? (
            <div className="ml-15 mr-15">
              <div className="d-flex flex-column mb-15">
                <div>
                  <Checkbox
                    className="portlet-label font-size14 mb-1"
                    onChange={(e) => handleCheckbox(e)}
                    value="allow_multiple_brand"
                    checked={checkboxValue?.allow_multiple_brand ? true : false}
                  >
                    Allow Brand Switching
                    <Tooltip
                      overlayInnerStyle={{
                        width: "35rem",
                        borderRadius: "0.7rem",
                      }}
                      placement="bottomRight"
                      title={
                        <span>
                          {`In the Shared Dashboard, switch between brands to
                          view and compare data. The selected brand will determine the data displayed in the
                          charts.`}
                        </span>
                      }
                    >
                      <img
                        src={informationButton}
                        alt="Info"
                        className="cursor-pointer ml-2"
                        style={{ maxWidth: "1.6rem" }}
                      />
                    </Tooltip>
                  </Checkbox>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            className={`floating-label-group header-brands mt-2 mb-2 ml-15 mr-15`}
            style={
              shareableUrl || panes[index]?.quick_filter
                ? {
                    pointerEvents: "none",
                    opacity: "0.6",
                    minWidth: "18rem",
                  }
                : { minWidth: "18rem" }
            }
          >
            {/* <Brand dropdown={true} type="share_modal" /> */}
            <div
              className={`${panes?.[index]?.is_brand_locked ? "disable" : ""}`}
            >
              <BrandsLogicalGroup dropdown={true} type="share_modal" />
            </div>
            <label
              className="portlet-label floating-label mr-15"
              style={{
                backgroundColor: "#fff",
                top: "-0.8rem",
                fontSize: "1.2rem",
              }}
            >
              For which brand you would like to generate a link ?
              <span style={{ color: "red" }}>*</span>
            </label>
            {sharedBrands && sharedBrands?.columns?.length === 0 && (
              <div className="error font-size12">
                Brand list cannot be empty
              </div>
            )}
          </div>
        </>
      )}
      {panes[index]?.quick_filter && !showLink ? (
        <>
          {graphConditionConfig?.["allow_multiple_selection_on_quick_filter"]
            ?.length > 0 &&
          graphConditionConfig?.[
            "allow_multiple_selection_on_quick_filter"
          ]?.includes(panes[index]?.quick_filter) ? (
            <div className="ml-15 mr-15">
              <div className="d-flex flex-column mb-15">
                <div>
                  <Checkbox
                    className="portlet-label font-size14 mb-1"
                    onChange={(e) => handleCheckbox(e)}
                    value="allow_multiple_selection"
                    checked={
                      checkboxValue?.allow_multiple_selection ? true : false
                    }
                  >
                    Allow {getNameFromQuickFilter(panes?.[index]?.quick_filter)}{" "}
                    {/* {getChannelNameFromHiddenFilter(
                      panes?.[index]?.hidden_filter,
                      graphConditionConfig
                    )}{" "} */}
                    Switching
                    <Tooltip
                      overlayInnerStyle={{
                        width: "35rem",
                        borderRadius: "0.7rem",
                      }}
                      placement="bottomRight"
                      title={
                        <span>
                          {`In the Shared Dashboard, switch between ${getNameFromQuickFilter(
                            panes?.[index]?.quick_filter
                          )}s to
                          view and compare data. The selected
                          ${getNameFromQuickFilter(
                            panes?.[index]?.quick_filter
                          )} will determine the data displayed in the
                          charts.`}
                        </span>
                      }
                    >
                      <img
                        src={informationButton}
                        alt="Info"
                        className="cursor-pointer ml-2"
                        style={{ maxWidth: "1.6rem" }}
                      />
                    </Tooltip>
                  </Checkbox>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            // style={{
            //   pointerEvents: "none",
            //   opacity: "0.6",
            // }}
            className="floating-label-group ml-15 mr-15 ProfileSelection ProfileSelection__sharemodal header-brands mb-2 analytics_brand"
          >
            <ProfileSelection
              AccountType={panes[index]?.quick_filter}
              type="share-modal"
              isSwitchingAllowed={
                checkboxValue?.allow_multiple_selection ? true : false
              }
            />
            <label
              className="portlet-label floating-label mr-15"
              style={{
                backgroundColor: "#fff",
                top: "-0.8rem",
                fontSize: "1.2rem",
              }}
            >
              {panes[index]?.quick_filter === "AccountID"
                ? "Profiles"
                : panes[index]?.quick_filter === "ObjectID"
                ? "Form"
                : panes[index]?.quick_filter === "LocationID"
                ? "Location"
                : panes[index]?.quick_filter?.toLowerCase() === "fbgroupid"
                ? "Facebook Group"
                : panes[index]?.quick_filter === "Ticket_Tagging"
                ? "Labels"
                : panes[index]?.quick_filter === "Category"
                ? "Category"
                : panes[index]?.quick_filter === "Ads_Campaign"
                ? "AD Campaign"
                : panes[index]?.quick_filter === "ProfileID"
                ? "Location Profiles"
                : panes[index]?.quick_filter === "CampaignID" && "Campaigns"}
            </label>
          </div>
          {panes[index]?.quick_filter === "Ads_Campaign" &&
          (checkboxValue?.allow_multiple_selection
            ? false // For temporary purpose not allowing selection for this, remove this condition later
            : profileSelectionInfo?.is_value_updated_from_share_modal
            ? Array.isArray(profileSelectionInfo?.adsset_list) &&
              profileSelectionInfo?.adsset_list?.length
            : Array.isArray(panes[index]?.adsset_list) &&
              panes[index]?.adsset_list?.length) ? (
            <div className="floating-label-group ml-15 mr-15 ProfileSelection ProfileSelection__sharemodal header-brands mb-2 analytics_brand">
              <ProfileSelection
                AccountType={panes[index]?.quick_filter}
                IsAdsSetType={true}
                type="share-modal"
                isSwitchingAllowed={
                  checkboxValue?.allow_multiple_selection ? true : false
                }
              />
              <label
                className="portlet-label floating-label mr-15"
                style={{
                  backgroundColor: "#fff",
                  top: "-8px",
                  fontSize: "12px",
                }}
              >
                {"AD Sets"}
              </label>
            </div>
          ) : (
            ""
          )}
          {panes[index]?.quick_filter === "Ads_Campaign" &&
          (checkboxValue?.allow_multiple_selection
            ? false // For temporary purpose not allowing selection for this, remove this condition later
            : profileSelectionInfo?.is_value_updated_from_share_modal
            ? Array.isArray(profileSelectionInfo?.ads_list) &&
              profileSelectionInfo?.ads_list?.length
            : Array.isArray(panes[index]?.ads_list) &&
              panes[index]?.ads_list?.length) ? (
            <div className="floating-label-group ml-15 mr-15 ProfileSelection ProfileSelection__sharemodal header-brands mb-2 analytics_brand">
              <ProfileSelection
                AccountType={panes[index]?.quick_filter}
                IsAdsType={true}
                type="share-modal"
                isSwitchingAllowed={
                  checkboxValue?.allow_multiple_selection ? true : false
                }
              />
              <label
                className="portlet-label floating-label mr-15"
                style={{
                  backgroundColor: "#fff",
                  top: "-8px",
                  fontSize: "12px",
                }}
              >
                {"ADs"}
              </label>
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {showLink && (
        <div className="form-group floating-label-group ml-15 mr-15 mt-15">
          <input
            id="SharedWith"
            className={`portlet-input w-100`}
            value={shareableUrl?.link ? shareableUrl?.link : "Loading Link..."}
            type="text"
            required
          />
          <label htmlFor="SharedWith" className="portlet-label floating-label">
            Share Link
          </label>
          <Tooltip
            title={isCopied ? "Link copied" : "Copy link"}
            onVisibleChange={() => setIsCopied(false)}
          >
            <CopyToClipboard
              disabled={shareableUrl?.link ? false : true}
              text={shareableUrl?.link}
              onCopy={onCopy}
              style={{
                top: "0",
                right: "0",
                paddingTop: !shareableUrl?.link ? "0.5rem" : "1.1rem",
                paddingBottom: !shareableUrl?.link ? "0.5rem" : "1rem",
                border: !shareableUrl?.link && "none",
                minHeight: "3.933rem",
              }}
              className="position-absolute btn_Clear"
            >
              <Button
                style={{
                  paddingTop: !shareableUrl?.link ? "0.5rem" : "1.1rem",
                  paddingBottom: !shareableUrl?.link ? "0.5rem" : "1rem",
                  minHeight: "3.933rem",
                }}
                className="btn_Clear border-0"
              >
                Copy
              </Button>
            </CopyToClipboard>
          </Tooltip>
        </div>
      )}

      {showRadio && (
        <div className="ml-15 mr-15">
          <div className="d-flex flex-column mb-2">
            <div>
              <Checkbox
                className="portlet-label font-size14 mb-1"
                onChange={(e) => handleCheckbox(e)}
                value="deep_dive_enabled"
                checked={checkboxValue?.deep_dive_enabled ? true : false}
              >
                Enable deep dive
              </Checkbox>
              <Checkbox
                className="portlet-label font-size14 mb-1"
                onChange={(e) => handleCheckbox(e)}
                value="filter_icon_enabled"
                checked={checkboxValue?.filter_icon_enabled ? true : false}
              >
                Show filter icon in shared dashboard
              </Checkbox>
            </div>
            <div>
              <Checkbox
                className="portlet-label font-size14 mb-1"
                onChange={(e) => handleCheckbox(e)}
                value="relative_dutation_enabled"
                checked={
                  checkboxValue?.relative_dutation_enabled ? true : false
                }
              >
                Show relative duration in shared dashboard
                <Tooltip
                  overlayInnerStyle={{
                    width: "35rem",
                    borderRadius: "0.7rem",
                  }}
                  placement="bottomRight"
                  title={
                    <span>
                      The shared dashboard shows relative date duration (e.g.,
                      last 8 days) instead of exact selected dates.
                    </span>
                  }
                >
                  <img
                    src={informationButton}
                    alt="Info"
                    className="cursor-pointer ml-2"
                    style={{ maxWidth: "1.6rem" }}
                  />
                </Tooltip>
              </Checkbox>
            </div>
            <Radio.Group onChange={handlePasswordOption} value={valuePassword}>
              <Radio className="portlet-label font-size12 mb-0" value={1}>
                Open for anyone
              </Radio>
              <Radio className="portlet-label font-size12 mb-0" value={2}>
                Password Protected
              </Radio>
            </Radio.Group>
          </div>

          {valuePassword === 2 && (
            <>
              <div className="form-group mb-15">
                <label
                  htmlFor="CreatePassword"
                  className="portlet-label font-weight500 d-block"
                >
                  Create Password
                </label>
                <Input.Password
                  id="CreatePassword"
                  placeholder="Password"
                  style={{ maxWidth: "25rem" }}
                  className="border border-color"
                  onChange={handleChangePassword}
                />
              </div>
              <label
                htmlFor="CreatePassword"
                className="portlet-label font-weight500 d-block"
              >
                Password must contain:
              </label>
              {passwordError && (
                <>
                  <span className="error font-size12">
                    Create your password
                  </span>{" "}
                </>
              )}
              <div className="d-flex">
                <span className="password-error-div">
                  {upperColor ? (
                    <CheckCircleFilled style={{ color: "green" }} />
                  ) : upperColor === false ? (
                    <CloseCircleFilled style={{ color: "red" }} />
                  ) : (
                    <div className="password-empty-icon"></div>
                  )}
                  <p
                    className="password-error-text font-size12"
                    style={{
                      color: upperColor
                        ? "green"
                        : upperColor === false
                        ? "red"
                        : "#7a89a0",
                    }}
                  >
                    Upper case letter (A-Z)
                  </p>
                </span>
                <span className="password-error-div">
                  {lowerColor ? (
                    <CheckCircleFilled style={{ color: "green" }} />
                  ) : lowerColor === false ? (
                    <CloseCircleFilled style={{ color: "red" }} />
                  ) : (
                    <div className="password-empty-icon"></div>
                  )}
                  <p
                    className="password-error-text font-size12"
                    style={{
                      color: lowerColor
                        ? "green"
                        : lowerColor === false
                        ? "red"
                        : "#7a89a0",
                    }}
                  >
                    Lower case letter (a-z)
                  </p>
                </span>
                <span className="password-error-div">
                  {specialColor ? (
                    <CheckCircleFilled style={{ color: "green" }} />
                  ) : specialColor === false ? (
                    <CloseCircleFilled style={{ color: "red" }} />
                  ) : (
                    <div className="password-empty-icon"></div>
                  )}
                  <p
                    className="password-error-text font-size12"
                    style={{
                      color: specialColor
                        ? "green"
                        : specialColor === false
                        ? "red"
                        : "#7a89a0",
                    }}
                  >
                    Special characters (@-#)
                  </p>
                </span>
              </div>
              <div className="d-flex">
                <span className="password-error-div">
                  {numberColor ? (
                    <CheckCircleFilled style={{ color: "green" }} />
                  ) : numberColor === false ? (
                    <CloseCircleFilled style={{ color: "red" }} />
                  ) : (
                    <div className="password-empty-icon"></div>
                  )}
                  <p
                    className="password-error-text font-size12"
                    style={{
                      margin: "0.5rem",
                      color: numberColor
                        ? "green"
                        : numberColor === false
                        ? "red"
                        : "#7a89a0",
                    }}
                  >
                    Number (0-9)
                  </p>
                </span>
                <span className="password-error-div">
                  {minColor ? (
                    <CheckCircleFilled style={{ color: "green" }} />
                  ) : minColor === false ? (
                    <CloseCircleFilled style={{ color: "red" }} />
                  ) : (
                    <div className="password-empty-icon"></div>
                  )}
                  <p
                    className="password-error-text font-size12"
                    style={{
                      color: minColor
                        ? "green"
                        : minColor === false
                        ? "red"
                        : "#7a89a0",
                    }}
                  >
                    Minimum 8 characters
                  </p>
                </span>
              </div>
            </>
          )}
          <Checkbox
            className="portlet-label font-size14 mb-1"
            onChange={(e) => handleExpiryDateVisibility(e)}
            checked={showDateTime}
          >
            <span className="portlet-label font-weight500 d-block">
              Set Expiry Date
            </span>
          </Checkbox>

          <div className={`${showDateTime ? "d-flex" : "d-none"}`}>
            <div
              className={`from-group floating-label-group d-flex`}
              style={{
                width: "100%",
                justifyContent: "space-between",
              }}
              ref={refDate}
            >
              <div style={{ flex: ".5" }}>
                <label className="portlet-label font-weight500 d-block">
                  Set expiry date:
                </label>
                <Popover
                  placement="bottom"
                  showArrow={false}
                  content={
                    <div className={`durationPopup d-block`}>
                      <span
                        className="close"
                        style={{ opacity: 1 }}
                        onClick={() => onCancel(true)}
                      >
                        &times;
                      </span>
                      <SetExpiryDatePicker
                        setDatepicker={setDatepicker}
                        localDate={localDate}
                        setLocalDate={setLocalDate}
                      />
                      <div className="durationPopup__footer p-10 border-top border-color text-right">
                        <div
                          className="d-flex"
                          style={{ justifyContent: "flex-end" }}
                        >
                          <Button
                            className="btn_Clear ml-15"
                            onClick={() => onCancel(true)}
                          >
                            Cancel
                          </Button>
                          <Button
                            key="submit"
                            type="primary"
                            className="ant-btn-primary_blue ml-15"
                            onClick={() => {
                              onDoneButton();
                            }}
                          >
                            Done
                          </Button>
                        </div>
                      </div>
                    </div>
                  }
                  title={null}
                  trigger="click"
                  open={datePicker}
                  onOpenChange={handleOpenChange}
                  className="w-100"
                  overlayClassName="expiry-date-calender"
                >
                  <div style={{ position: "relative" }}>
                    <Input
                      id="Duration"
                      className="portlet-input w-100 cursor-pointer no-animation"
                      value={localDate}
                      onClick={(e) => onOpen(e)}
                      type="text"
                      required
                      readOnly
                      placeholder="Select Date"
                    />
                    <img
                      src={Calender_blue}
                      className="durationIcon"
                      alt="duration Icon"
                      style={{ width: "2rem", maxWidth: "none" }}
                    />
                  </div>
                </Popover>
              </div>
              <div className="share-dash-modal-time">
                <label
                  htmlFor="Setexpirytime:"
                  className="portlet-label font-weight500 d-block"
                >
                  Set expiry time:
                </label>
                <div style={{ position: "relative" }} ref={dropdownRef}>
                  <Input
                    id="Duration"
                    style={{ maxWidth: "25rem" }}
                    className="portlet-input border border-color no-animation"
                    value={selectedTime}
                    readOnly
                    disabled={!localDate}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  />
                  <img
                    src={Clock}
                    className="durationIcon"
                    width={"2rem"}
                    alt="clock-icon"
                    style={{ width: "2rem", maxWidth: "none" }}
                  />
                </div>
                {isDropdownOpen && (
                  <ul className="custom_scroll1 share-dash-modal-time-dropdown">
                    {timeOptions?.map((time, index) => (
                      <li
                        key={index}
                        className="mr-1 text_regular text-ellipsis"
                        onClick={() => handleTimeSelect(time)}
                        style={{
                          padding: "0.8rem 0.8rem 0.2rem",
                          cursor: isTimeDisabled(time)
                            ? "not-allowed"
                            : "pointer",
                          opacity: isTimeDisabled(time) ? ".5" : "1",
                        }}
                      >
                        {time}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        ref={bottom}
        className="text-right bg__white border-top border-color mt-15 p-15"
        style={{ borderRadius: "0 0 1rem 1rem" }}
      >
        <Button
          disabled={
            (valuePassword === 2 &&
              !upperColor &&
              !lowerColor &&
              !specialColor &&
              !numberColor &&
              !minColor) ||
            shareableUrl?.link ||
            (sharedBrands && sharedBrands?.columns?.length === 0)
              ? true
              : false
          }
          style={{ color: "#fff" }}
          className="ant-btn-primary_blue"
          onClick={() => generateSharableLink()}
        >
          Generate Shareable Link
        </Button>
      </div>
    </div>
  );
};

export default SharePassword;
